import { render } from "./Restaurant.vue?vue&type=template&id=2fdd15d3&scoped=true"
import script from "./Restaurant.vue?vue&type=script&lang=js"
export * from "./Restaurant.vue?vue&type=script&lang=js"

import "./Restaurant.vue?vue&type=style&index=0&id=2fdd15d3&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdd15d3"]])

export default __exports__